import { createAsyncThunk } from '@reduxjs/toolkit';
import { selectSelectedProjectId } from 'store/projects/selectors/projectsSelectors';
import {
  selectFirestopListAttributeModifications,
  selectSelectedFirestopListId,
} from '../selectors/firestop-documentation.selectors';
import { patchUpdateFirestopListAttributes } from '../services/patch-update-firestop-list-attributes.service';

export const saveFirestopListChanges = createAsyncThunk(
  'firestopDocumentation/saveFirestopListChanges',
  async (_, { getState, rejectWithValue }) => {
    const selectedFirestopListId = selectSelectedFirestopListId(getState());
    const selectedProjectId = selectSelectedProjectId(getState());
    const firestopListAttributeModifications =
      selectFirestopListAttributeModifications(getState());

    try {
      const updatedFirestopListData = await patchUpdateFirestopListAttributes(
        selectedProjectId,
        selectedFirestopListId,
        firestopListAttributeModifications
      );

      return updatedFirestopListData;
    } catch (error) {
      return rejectWithValue(error?.message || 'Save failed');
    }
  }
);
